enum KeyCodes {
  TAB = 9,
  ENTER = 13,
  ESCAPE = 27,
  SPACE = 32,
  ARROW_LEFT = 37,
  ARROW_UP = 38,
  ARROW_RIGHT = 39,
  ARROW_DOWN = 40,
}

enum Key {
  ENTER = 'Enter',
  SPACEBAR = 'Spacebar',
  SPACEBAR_ALT = ' ',
  ARROW_LEFT = 'ArrowLeft',
  ARROW_LEFT_ALT = 'Left',
  ARROW_RIGHT = 'ArrowRight',
  ARROW_RIGHT_ALT = 'Right',
  ARROW_UP = 'ArrowUp',
  ARROW_UP_ALT = 'Up',
  ARROW_DOWN = 'ArrowDown',
  ARROW_DOWN_ALT = 'Down',
}

export class EventKeyManager {
  static isEnter(event) {
    return (event.key ? event.key === Key.ENTER : event.keyCode === KeyCodes.ENTER) && !this.hasModifierKeys(event);
  }

  static isSpace(event) {
    return (
      (event.key ? event.key === Key.SPACEBAR || event.key === Key.SPACEBAR_ALT : event.keyCode === KeyCodes.SPACE) &&
      !this.hasModifierKeys(event)
    );
  }

  static isLeft(event) {
    return (
      (event.key
        ? event.key === Key.ARROW_LEFT || event.key === Key.ARROW_LEFT_ALT
        : event.keyCode === KeyCodes.ARROW_LEFT) && !this.hasModifierKeys(event)
    );
  }

  static isRight(event) {
    return (
      (event.key
        ? event.key === Key.ARROW_RIGHT || event.key === Key.ARROW_RIGHT_ALT
        : event.keyCode === KeyCodes.ARROW_RIGHT) && !this.hasModifierKeys(event)
    );
  }

  static isUp(event) {
    return (
      (event.key
        ? event.key === Key.ARROW_UP || event.key === Key.ARROW_UP_ALT
        : event.keyCode === KeyCodes.ARROW_UP) && !this.hasModifierKeys(event)
    );
  }

  static isDown(event) {
    return (
      (event.key
        ? event.key === Key.ARROW_DOWN || event.key === Key.ARROW_DOWN_ALT
        : event.keyCode === KeyCodes.ARROW_DOWN) && !this.hasModifierKeys(event)
    );
  }

  static getCtrlKey(event) {
    return event.metaKey || event.ctrlKey;
  }

  static hasModifierKeys(event): boolean {
    return event.shiftKey || event.altKey || this.getCtrlKey(event);
  }

  static isPrintable(event): boolean {
    // Check if the key is a single printable character (letters, numbers, symbols)
    return event.key ? event.key.length === 1 && /\w|\p{P}|\p{S}/u.test(event.key) : false;
  }
}
